import { Slider } from '@luminara/ui-components';
import { MAX_SOUNDTRACK_VOLUME_LEVEL } from '../../../../constants/app-constants';
import { cn } from '@luminara/ui-components';

type SliderProps = React.ComponentProps<typeof Slider>;

const VolumeSlider: React.FC<SliderProps> = ({ value, defaultValue, onValueChange, className, ...props }: SliderProps) => {
  return (
    <Slider
      max={MAX_SOUNDTRACK_VOLUME_LEVEL}
      step={0.0001}
      min={-0.0001}
      value={value}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      className={cn('w-[59%]', className)}
      {...props}
    />
  );
};

export default VolumeSlider;
